import { render, staticRenderFns } from "./Func138TrocarSenha.vue?vue&type=template&id=0f67c1dc&scoped=true"
import script from "./Func138TrocarSenha.vue?vue&type=script&lang=js"
export * from "./Func138TrocarSenha.vue?vue&type=script&lang=js"
import style0 from "./Func138TrocarSenha.vue?vue&type=style&index=0&id=0f67c1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67c1dc",
  null
  
)

export default component.exports